import React, { useContext, useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import PortfolioContext from '../../context/context';

const Header = () => {
  const { hero } = useContext(PortfolioContext);
  const { title, name, cta } = hero;

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="hero" className="jumbotron">
      <Container>
        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={500} distance="30px">
          <h1 className="hero-title">
            {title || 'Hi there, join our '} <br />
            <span className="text-color-main">{name || 'Scuba and Freediving '}</span>
            {title || 'Discord Community'} <br />
          </h1>
        </Fade>
        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
          <a href="https://discord.gg/BSsXcyEKYq" target="_blank" rel="noreferrer">
            <p className="hero-cta">
              <span className="cta-btn cta-btn--hero">
                {cta || 'Join Discord'}
                &nbsp;&nbsp;&nbsp;&nbsp;
                <img
                  src="https://img.icons8.com/color/48/000000/discord-logo.png"
                  alt="Discord logo"
                />
              </span>
            </p>
          </a>
        </Fade>
      </Container>
    </section>
  );
};

export default Header;
